module.exports = __webpack_public_path__ + "img/doc-uploaded.cf02e0dc.svg";